import RoleTemplateHashTableTypes from "../types/hashTableTypes/RoleTemplateHashTableTypes"
import PortalRoleTemplateWithLnksTypes from "../types/portalTemplateTypes/PortalRoleTemplateWithLnksTypes"
import saveTemplateSetup from "./SaveTemplateSetup"
import ratmService from "./RATMService"
import ratmHash from "./RATMHash"

const auditTemplate = (templateToAddOrUpdate: PortalRoleTemplateWithLnksTypes) => {
    let forbiddedRoles: string[] = []
    const { state } = ratmService
    const { lookupHashTableItem } = ratmHash
    const template: RoleTemplateHashTableTypes = lookupHashTableItem(state.addOrEditTemplateId, 1)
    if (template) {
        const saveSetupResult = saveTemplateSetup(templateToAddOrUpdate)
        const isProtected = templateToAddOrUpdate.Template.IsProtected
        if (!isProtected) {
            const allLinks = [...templateToAddOrUpdate.RoleTemplatePortalRoleLnk, ...saveSetupResult.RoleTemplatePortalRoleLnk]
            for (let i = 0; i < allLinks.length; i++) {
                const link = allLinks[i]
                const portalRoleBucketItem = lookupHashTableItem(link.PortalRoleId ? link.PortalRoleId : -1, 0)
                if (portalRoleBucketItem) {
                    const linkedFromHash = ratmHash.lookupHashTableItem(portalRoleBucketItem[1].role.PortalRoleId, 2)
                    if ((linkedFromHash && ((linkedFromHash[2].permissions.addRole || linkedFromHash[2].permissions.hasRole) && !linkedFromHash[2].permissions.dropRole)) && portalRoleBucketItem[1].role.IsProtected) {
                        forbiddedRoles.push(portalRoleBucketItem[1].role.RoleName)
                    }
                }
            }
        }
    }
    const name = templateToAddOrUpdate.Template.Name
    const description = templateToAddOrUpdate.Template.Description
    const missingName = !(name !== null && name.trim().length > 0)
    const missingDescription = !(description !== null && description.trim().length > 0)
    const canSave = forbiddedRoles.length < 1 && !missingName && !missingDescription
    return { canSave: canSave, forbiddedRoles: forbiddedRoles, missingName: missingName, missingDescription: missingDescription }
}

export default auditTemplate